import { render, staticRenderFns } from "./MinisitePaylinkConfirmation.vue?vue&type=template&id=47474741&"
import script from "./MinisitePaylinkConfirmation.vue?vue&type=script&lang=js&"
export * from "./MinisitePaylinkConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports